import axiosInstance from '@/shared/api/axios';
import type {
  ApiSplitsDetailGetResponse,
  ApiSplitsListGetResponse,
  ApiSplitsPostBody,
  ApiSplitsSavePostBody,
} from '@/shared/types/api/splits';

export const apiSplitsPost = async (
  body: ApiSplitsPostBody,
): Promise<ApiSplitsDetailGetResponse> => {
  const { data } = await axiosInstance.post<ApiSplitsDetailGetResponse>('/splits/', body);
  return data;
};

export const apiSplitDetailGet = async (id: string): Promise<ApiSplitsDetailGetResponse> => {
  const { data } = await axiosInstance.get<ApiSplitsDetailGetResponse>(`/splits/${id}`);
  return data;
};

export const apiSplitsListGet = async (
  parcelId?: string,
): Promise<ApiSplitsListGetResponse> => {
  const { data } = await axiosInstance.get<ApiSplitsListGetResponse>('/splits/', {
    params: parcelId ? { parcel: parcelId } : undefined,
  });
  return data;
};

// POST /splits/{id}/targets — client (owner-permitted) endpoint. Persists the
// targets as a DRAFT (status stays DRAFT; no charges, no packages created). Body
// is { targets: [...] } without package_price / unique_id / service_fee (all
// admin/server-managed). The previous /save endpoint is staff-only (403 for
// clients), so the client saves a draft here and an admin distributes later.
export const apiSplitSave = async (
  id: string,
  body: ApiSplitsSavePostBody,
): Promise<ApiSplitsDetailGetResponse> => {
  const { data } = await axiosInstance.post<ApiSplitsDetailGetResponse>(
    `/splits/${id}/targets`,
    body,
  );
  return data;
};

// POST /splits/{id}/confirm-shipping — client (owner-permitted) endpoint. This
// dedicated, cargo_id-aware handler confirms shipping for a split's parcel and
// returns the serialized split (NOT a {confirmed, skipped} summary). Use this
// instead of the generic /parcels/confirm-shipping, which filters strictly by
// user_id and 400s for cargo_id-owned (admin-created, user-less) parcels.
export const apiSplitConfirmShipping = async (
  id: string,
): Promise<ApiSplitsDetailGetResponse> => {
  const { data } = await axiosInstance.post<ApiSplitsDetailGetResponse>(
    `/splits/${id}/confirm-shipping`,
  );
  return data;
};